// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
}

:root {
  --primary-color: #333;
  --secondary-color: #444;
  --accent-color: #666;
}
.blogDetail_wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
}
.details_main {
  height: 100%;
  width: 100%;
  background-color: beige;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
}
.details_main p {
  font-family: Poppins;
  text-align: center;
}
.blogcard_title {
  font-size: 30px;
  font-weight: 600;
  margin: 0.7rem 0 0.4rem 0;
}
.blogcard_subtitle {
  font-size: 24px;
  font-weight: 500;
}
.blogcard_des {
  font-size: 18px;
  margin: 0.5rem 0;
}
.back_button {
  /* background-color: #e0eef6;
  border-radius: 40px;
  font-size: medium;
  padding: 2%; */
  margin-right: 10px;
  cursor: pointer;
}
.form_comp {
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
}
.form_comp label {
  font-family: Poppins;
  font-size: 16px;
  font-weight: 600;
  margin: 0.3rem 0 0.2rem 0;
  color: #333;
}
.form_comp input {
  padding: 0.5rem;
  border-radius: 4px;
  outline: none;
  border: 1px solid #d1cece;
  font-size: 16px;
}
.form_comp select {
  padding: 0.5rem;
  border-radius: 4px;
  outline: none;
  border: 1px solid #d1cece;
  font-size: 16px;
}
.form_comp textarea {
  padding: 0.5rem;
  border-radius: 4px;
  outline: none;
  border: 1px solid #d1cece;
  font-size: 16px;
  font-family: Poppins;
}
.form_comp_subtitle {
  margin-top: 20px;
}
.confirm_btn {
  width: 200px;
  font-size: 18px;
  font-family: Poppins;
  margin: 0.7rem 0 2rem 0;
  padding: 0.35rem 0.9rem;
  background-color: #312968;
  color: white;
  border: none;
  border-radius: 5px;
}
.blog_heading {
  font-size: 30px;
  font-family: Poppins;
  font-weight: 600;
  padding: 2rem 0 0 3rem;
}
.modal_btn {
  width: 150px;
  font-size: 18px;
  font-family: Poppins;
  margin: 0.7rem;
  padding: 0.45rem 0.9rem;
  color: white;
  border: none;
  border-radius: 5px;
}

.tablecell {
  font-weight: 600;
}
.mr5 {
  margin-right: 5px;
}
.mr10 {
  margin-right: 10px;
}
.pointer {
  cursor: pointer;
}

.mt5 {
  margin-top: 5px;
}
.mt15 {
  margin-top: 15px;
}
.mb15 {
  margin-bottom: 15px;
}
.fw {
  width: 100%;
}
.mUpload-item {
  border: 1px solid #b9b9b9;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
}
.MuiAccordion-root {
  border: 1px solid #b9b9b9;
}
.float-right {
  float: right;
}

.c1 {
  background-color: #17a2b8;
}
.c2 {
  background-color: #7367f0;
}
.c3 {
  background-color: yellowgreen;
}

.img-main-container {
  display: flex;
  justify-content: space-between;
}

.img-inner-container {
  display: flex;
  flex-direction: column;
  margin-top: 0.5rem;
  width: 100%;
}

.cb-o-cb {
  position: relative;
  font-family: Poppins;
  max-width: 900px;
  margin: 50px auto;
  border: 1px solid rgba(224, 224, 224, 1);
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  padding-top: 30px;
  padding-bottom: 30px;
  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
}

.form_o_cb {
  max-width: 1000px;
  margin: 50px auto 0;
}

.form_o_cb * {
  font-family: Poppins;
}

.i-cb {
  font-family: inherit;
  flex: 0 0 auto;
  width: 50%;
  margin-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
}

.full-w-cb {
  flex: 0 0 auto;
  width: 100%;
  padding-top: 20px;
  border-top: 1px solid rgba(224, 224, 224, 1);
  margin-top: 20px;
}

.i-cb strong {
  display: flex;
  min-width: 150px;
  padding-left: 20px;
  padding-right: 20px;
}

.i-cb span {
  padding-left: 20px;
  padding-right: 20px;
}

.form_row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.form_col_6 {
  flex: 0 0 auto;
  width: 50%;
  padding-left: 15px;
  padding-right: 15px;
  margin-bottom: 15px;
}

.form_container_box {
  position: relative;
  font-family: inherit;
}

.form_container_box label {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  display: block;
  font-family: inherit;
  margin-bottom: 5px;
}

.form_container_box input,
.form_container_box select,
.form_container_box textarea {
  border: 1px solid #d1cece;
  border-radius: 4px;
  font-size: 16px;
  outline: none;
  padding: 0.5rem;
  width: 100%;
}

.set_height,
.css-1fdsijx-ValueContainer {
  height: 44px;
}

.btn_o_c {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
}

.loading_cb {
  margin: 0;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 1rem;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;;;gBAGc;EACd,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB;4EAC0E;AAC5E;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,uDAAuD;EACvD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Poppins:wght@300&display=swap\");\n* {\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --primary-color: #333;\n  --secondary-color: #444;\n  --accent-color: #666;\n}\n.blogDetail_wrapper {\n  width: 100%;\n  height: 100%;\n  display: grid;\n  place-items: center;\n}\n.details_main {\n  height: 100%;\n  width: 100%;\n  background-color: beige;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  overflow-y: auto;\n}\n.details_main p {\n  font-family: Poppins;\n  text-align: center;\n}\n.blogcard_title {\n  font-size: 30px;\n  font-weight: 600;\n  margin: 0.7rem 0 0.4rem 0;\n}\n.blogcard_subtitle {\n  font-size: 24px;\n  font-weight: 500;\n}\n.blogcard_des {\n  font-size: 18px;\n  margin: 0.5rem 0;\n}\n.back_button {\n  /* background-color: #e0eef6;\n  border-radius: 40px;\n  font-size: medium;\n  padding: 2%; */\n  margin-right: 10px;\n  cursor: pointer;\n}\n.form_comp {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: 0.5rem;\n}\n.form_comp label {\n  font-family: Poppins;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0.3rem 0 0.2rem 0;\n  color: #333;\n}\n.form_comp input {\n  padding: 0.5rem;\n  border-radius: 4px;\n  outline: none;\n  border: 1px solid #d1cece;\n  font-size: 16px;\n}\n.form_comp select {\n  padding: 0.5rem;\n  border-radius: 4px;\n  outline: none;\n  border: 1px solid #d1cece;\n  font-size: 16px;\n}\n.form_comp textarea {\n  padding: 0.5rem;\n  border-radius: 4px;\n  outline: none;\n  border: 1px solid #d1cece;\n  font-size: 16px;\n  font-family: Poppins;\n}\n.form_comp_subtitle {\n  margin-top: 20px;\n}\n.confirm_btn {\n  width: 200px;\n  font-size: 18px;\n  font-family: Poppins;\n  margin: 0.7rem 0 2rem 0;\n  padding: 0.35rem 0.9rem;\n  background-color: #312968;\n  color: white;\n  border: none;\n  border-radius: 5px;\n}\n.blog_heading {\n  font-size: 30px;\n  font-family: Poppins;\n  font-weight: 600;\n  padding: 2rem 0 0 3rem;\n}\n.modal_btn {\n  width: 150px;\n  font-size: 18px;\n  font-family: Poppins;\n  margin: 0.7rem;\n  padding: 0.45rem 0.9rem;\n  color: white;\n  border: none;\n  border-radius: 5px;\n}\n\n.tablecell {\n  font-weight: 600;\n}\n.mr5 {\n  margin-right: 5px;\n}\n.mr10 {\n  margin-right: 10px;\n}\n.pointer {\n  cursor: pointer;\n}\n\n.mt5 {\n  margin-top: 5px;\n}\n.mt15 {\n  margin-top: 15px;\n}\n.mb15 {\n  margin-bottom: 15px;\n}\n.fw {\n  width: 100%;\n}\n.mUpload-item {\n  border: 1px solid #b9b9b9;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px;\n}\n.MuiAccordion-root {\n  border: 1px solid #b9b9b9;\n}\n.float-right {\n  float: right;\n}\n\n.c1 {\n  background-color: #17a2b8;\n}\n.c2 {\n  background-color: #7367f0;\n}\n.c3 {\n  background-color: yellowgreen;\n}\n\n.img-main-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.img-inner-container {\n  display: flex;\n  flex-direction: column;\n  margin-top: 0.5rem;\n  width: 100%;\n}\n\n.cb-o-cb {\n  position: relative;\n  font-family: Poppins;\n  max-width: 900px;\n  margin: 50px auto;\n  border: 1px solid rgba(224, 224, 224, 1);\n  border-radius: 5px;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  -ms-border-radius: 5px;\n  -o-border-radius: 5px;\n  box-sizing: border-box;\n  display: flex;\n  flex-wrap: wrap;\n  padding-top: 30px;\n  padding-bottom: 30px;\n  box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),\n    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);\n}\n\n.form_o_cb {\n  max-width: 1000px;\n  margin: 50px auto 0;\n}\n\n.form_o_cb * {\n  font-family: Poppins;\n}\n\n.i-cb {\n  font-family: inherit;\n  flex: 0 0 auto;\n  width: 50%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.full-w-cb {\n  flex: 0 0 auto;\n  width: 100%;\n  padding-top: 20px;\n  border-top: 1px solid rgba(224, 224, 224, 1);\n  margin-top: 20px;\n}\n\n.i-cb strong {\n  display: flex;\n  min-width: 150px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.i-cb span {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.form_row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.form_col_6 {\n  flex: 0 0 auto;\n  width: 50%;\n  padding-left: 15px;\n  padding-right: 15px;\n  margin-bottom: 15px;\n}\n\n.form_container_box {\n  position: relative;\n  font-family: inherit;\n}\n\n.form_container_box label {\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n  display: block;\n  font-family: inherit;\n  margin-bottom: 5px;\n}\n\n.form_container_box input,\n.form_container_box select,\n.form_container_box textarea {\n  border: 1px solid #d1cece;\n  border-radius: 4px;\n  font-size: 16px;\n  outline: none;\n  padding: 0.5rem;\n  width: 100%;\n}\n\n.set_height,\n.css-1fdsijx-ValueContainer {\n  height: 44px;\n}\n\n.btn_o_c {\n  margin-top: 30px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 30px;\n}\n\n.loading_cb {\n  margin: 0;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  font-weight: 400;\n  font-size: 1rem;\n  line-height: 1.5;\n  letter-spacing: 0.00938em;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
